const viewAny = (permissions) => {
  return permissions.includes('read-newsletter')
}

const list = (permissions) => {
  return permissions.includes('read-newsletter')
}

const create = (permissions) => {
  return hasPermission(permissions, 'create-newsletter')
}

const update = (permissions, newsletter) => {
  return hasPermission(permissions, 'update-newsletter')
}

const deletee = (permissions, newsletter) => {
  return hasPermission(permissions, 'delete-newsletter')
}

const hasPermission = (permissions, permission) => {
  return permissions.includes(permission)
}

export {
  viewAny,
  list,
  create,
  update,
  deletee,
  hasPermission,
};